import React from 'react';
// import ItemTypes from './ItemTypes';
// import BoxDragPreview from './BoxDragPreview';
// import snapToGrid from './snapToGrid';
import { DragLayer } from 'react-dnd';

const layerStyles = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  // width: '100%',
  // height: '100%'
};

function getItemStyles(props) {
  const { currentOffset } = props;
  if (!currentOffset) {
    return {
      display: 'none'
    };
  }

  const { x, y } = currentOffset;
  const transform = `translate(${x}px, ${y}px)`;
  return {
    transform: transform
  };
}

function CustomDragLayer(props) {
  const { item, itemType, isDragging } = props;
  if (!isDragging) {
    return null;
  }

  function renderItem(type, item) {
    switch (type) {
      case 'chart-series':
        return (
          <div
            className="row v-center"
            style={{
              background: 'rgba(255,255,255,0.7)',
              boxShadow: '1px 1px 4px rgba(0,0,0,0.3)',
              padding: 5,
              borderRadius: 5,
              color: item.color,
              textTransform: 'uppercase',
              letterSpacing: '0.05em',
              fontSize: 12
            }}
          >
            <div style={{ width: 10, height: 10, marginRight: 5, backgroundColor: item.color }} />
            {item.name}
          </div>
        );
    }
  }

  return (
    <div style={layerStyles}>
      <div style={getItemStyles(props)}>{renderItem(itemType, item)}</div>
    </div>
  );
}

function collect(monitor) {
  return {
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging()
  };
}

export default DragLayer(collect)(CustomDragLayer);
